export default "__VITE_ASSET__CjZS$hyD__"